import React from 'react';
import { Outlet } from 'react-router-dom' ;
import "./messages.css" ; 

const MessagesPage = () => {
  return (
    <section className='message-section'>
        <Outlet />
    </section>
  )
}

export default MessagesPage;
